module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-layout', {
    attrs: {
      "title": _vm.title
    }
  }, [(_vm.multipage) ? _c('keep-alive', [_c('router-view', {
    ref: "page"
  })], 1) : _c('router-view', {
    ref: "page"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-2e86d83e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/common/PageView.vue
// module id = SFxE
// module chunks = 273